import addSeparator from '../../utils/strings/addSeparator'
import { Text } from '@talkdesk/cobalt-react-typography'
import Grid, { Column } from '@talkdesk/cobalt-react-grid'
import Box from '@talkdesk/cobalt-react-box'

const chunk = (arr, size) =>
  Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
    arr.slice(i * size, i * size + size),
  )

const renderListElement = (element) => (
  <Column length='1' key={element}>
    <Text truncated textAlign='center'>
      {addSeparator(element, 3, ' ')}
    </Text>
  </Column>
)

const renderRow = (row, index) => (
  <Grid columns='3' gap='3' key={index}>
    {row.map((element) => {
      return renderListElement(element)
    })}
  </Grid>
)

const RecoveryOTPList = (props) => (
  <Box width='100%' paddingX='9' paddingY='5'>
    {chunk(props.otpList, 3).map((row, index) => {
      return renderRow(row, index)
    })}
  </Box>
)

export default RecoveryOTPList
